const env = import.meta.env ?? {};

export const config = {
  /** Endpoint that resolves a qrCodeId to its target URL. */
  apiUrl: env.VITE_QR_API_URL || 'https://api.dam.ecollat.in/public/qr',

  /** Give up and show the error state after this long. */
  timeoutMs: Number(env.VITE_TIMEOUT_MS) || 12000,

  /**
   * Optional. Where to send visitors when a code fails to resolve for a
   * reason that is ours rather than theirs. A missing code always shows the
   * 404 page instead.
   */
  fallbackUrl: env.VITE_FALLBACK_URL || '',
};

/** Shape of a QR code id, e.g. "nZJQXo4f4Ooq". */
export const QR_CODE_ID_PATTERN = /^[A-Za-z0-9_-]{4,64}$/;

export const isValidQrCodeId = (value) =>
  typeof value === 'string' && QR_CODE_ID_PATTERN.test(value);
